import { createRoute } from '@tanstack/react-router';
import { lazy, Suspense } from 'react';
import { Route as RootRoute } from './__root';

const UkolUpravit = lazy(() =>
  import('@/modules/ukoly/UkolUpravit').then((m) => ({ default: m.UkolUpravit })),
);

export const Route = createRoute({
  getParentRoute: () => RootRoute,
  path: '/ukoly/$id/upravit',
  component: () => (
    <Suspense fallback={null}>
      <UkolUpravit />
    </Suspense>
  ),
});
